import { CONFIG } from '@/utils/constants';

export const getUrlParameter = (name) => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/**
 * Hide element by setting display to none
 * @param id {string}
 */
export function hideContent(id) {
  const content = document.getElementById(id);
  if (content) {
    content.style.display = 'none';
  }
}

export function getConfigKey(key, localConfig) {
  const localKey = localConfig[key];
  const windowKey = window.config ? window.config[key] : undefined;
  return windowKey || localKey;
}

export const isArray = (obj) => Object.prototype.toString.call(obj) === '[object Array]';

export function trackJs(message) {
  window.trackJs && window.trackJs.track(message);
}

/**
 * Determine if passed number is on range
 * @param {number} number
 * @param {Array<number>} range
 * @param {boolean} strict
 * @returns {boolean}
 */
export function isInRange(number, range, strict = true) {
  return strict ? number >= range[0] && number <= range[1] : number > range[0] && number < range[1];
}

/**
 * Add inso_price to passed data param if config has required keys, otherwise call error handler
 * @param {Object} config
 * @param {Object} data
 * @param {Function|jest.Mock} errorCallback
 * @returns {*}
 */
export function addRandomInsoPrice(config, data, errorCallback = trackJs) {
  try {
    const variations = config[CONFIG.INSO_PRICE_VARIATIONS];
    const defaultInsoPrice = config[CONFIG.INSO_PRICE_DEFAULT];
    if (!variations || !defaultInsoPrice) {
      throw new Error('insoPriceVariations or insoPriceDefault is not present at leadfunnel.config');
    }
    // Validate config for correct values
    Object.keys(variations).forEach((variation) => {
      if (variations[variation].price) {
        if (Number.isNaN(Number.parseFloat(variations[variation].price))) {
          throw new Error(`insoPriceVariations variation "${variation}" price is not integer or float`);
        }
      } else {
        throw new Error(`insoPriceVariations variation "${variation}" has no price`);
      }
      if (variations[variation].percentage) {
        if (
          typeof variations[variation].percentage[0] !== 'number' ||
          typeof variations[variation].percentage[1] !== 'number'
        ) {
          throw new Error(
            `insoPriceVariations variation "${variation}" percentage is of wrong type, must be array of integers`,
          );
        }
      } else {
        throw new Error(`insoPriceVariations variation "${variation}" has no percentage`);
      }
    });
    // Do calculations after validation
    const randomNumber = Math.round(Math.random() * 100);
    const ranges = Object.keys(variations).reduce((arr, variation) => {
      arr.push(variations[variation].percentage);
      return arr;
    }, []);
    const indexOfRange = ranges.findIndex((range) => isInRange(randomNumber, [range[0], range[1]]));
    return indexOfRange >= 0
      ? Object.assign(data, { inso_price: variations[Object.keys(variations)[indexOfRange]].price })
      : Object.assign(data, { inso_price: defaultInsoPrice });
  } catch (e) {
    errorCallback(e.message);
  }
}

export function render(condition, el1, el2) {
  if (typeof el2 !== 'undefined') {
    return condition ? el1 : el2;
  } else {
    return condition ? el1 : null;
  }
}

export function getValueByCondition(conditionList) {
  if (typeof conditionList === 'string') return conditionList;
  const firstEvaluatedSubtitle = conditionList.find(({ condition }) => eval(condition));
  if (firstEvaluatedSubtitle) return firstEvaluatedSubtitle.value;
  const firstNonConditionSubtitle = conditionList.find(({ condition }) => !condition);
  if (firstNonConditionSubtitle) return firstNonConditionSubtitle.value;
  return '';
}

export function whichUrlShouldBePassed(href = '/') {
  return href.indexOf('staging') > -1 || href.indexOf('localhost') > -1;
}

export function getClientSecretTargetUrl(condition) {
  return condition
    ? 'https://staging-a-vollmacht-fe-v2.k-staging.legalone.io/?secret={clientSecretId}'
    : 'https://crm-vollmacht.sos-verkehrsrecht.de/?secret={clientSecretId}';
}
